<div class="master-data-layout-editor">
  <div class="d-flex align-items-baseline mb-4">
    <h2 class="mb-0">{{_(KEYS.MASTER_DATA.TITLE)}}</h2>
    <span class="badge badge-warning ml-3 unsaved-badge" *ngIf="hasUnsavedChanges">
      <i class="fa fa-exclamation-triangle"></i> {{_(KEYS.MASTER_DATA.UNSAVED_CHANGES)}}
    </span>
  </div>

  <div class="alert alert-info mt-2 mb-0" style="width: 637px">
    <i class="fa fa-info-circle"></i>
    {{_(KEYS.MASTER_DATA.HINT)}}
  </div>
  <br>

  <!-- Controls -->
  <div class="layout-controls mb-3">
    <div class="d-flex align-items-center mb-2">
      <i class="fa fa-th mr-2"></i>
      <strong>{{_(KEYS.MASTER_DATA.LAYOUT_EDITOR)}}</strong>
    </div>

    <div class="d-flex align-items-center">
      <div class="input-group mr-3" style="width: auto;">
        <span class="input-group-addon">{{_(KEYS.MASTER_DATA.GRID_SIZE)}}:</span>
        <select class="form-control custom-select" (change)="onGridSizeChange(gridPresets[$event.target.selectedIndex])">
          <option *ngFor="let preset of gridPresets" [selected]="isGridSizeSelected(preset)">
            {{getGridSizeLabel(preset)}}
          </option>
        </select>
      </div>
    </div>
  </div>

  <div class="layout-container d-flex mt-4">
    <!-- Available fields -->
    <div class="available-fields mr-4">
      <h6>{{_(KEYS.MASTER_DATA.AVAILABLE_FIELDS)}}</h6>

      <!-- Search field -->
      <div class="field-search mb-2">
        <div class="input-group input-group-sm">
          <span class="input-group-addon"><i class="fa fa-search"></i></span>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="fieldSearchTerm"
            [placeholder]="_(KEYS.MASTER_DATA.SEARCH_FIELDS)"
          >
          <span class="input-group-btn" *ngIf="fieldSearchTerm">
            <button class="btn btn-secondary" type="button" (click)="fieldSearchTerm = ''">
              <i class="fa fa-times"></i>
            </button>
          </span>
        </div>
      </div>

      <!-- Scrollable fields container -->
      <div class="available-fields-scroll">
        <!-- Standard fields section -->
        <div class="fields-section">
          <div class="fields-section-header">{{_(KEYS.MASTER_DATA.STANDARD_FIELDS)}}</div>
          <div class="available-fields-list" [dragula]="'master-data-fields'">
            <div
              *ngFor="let def of filteredStandardFields"
              class="available-field drag-handle field-type-standard"
              [attr.data-field-key]="def.key"
              [attr.data-field-type]="'standard'"
            >
              <i class="fa fa-arrows mr-2"></i>
              {{_(KEYS.CRUD[def.labelKey] || def.labelKey)}}
            </div>
            <div *ngIf="availableStandardFields.length === 0" class="text-muted small mb-2">
              {{_(KEYS.MASTER_DATA.ALL_STANDARD_PLACED)}}
            </div>
            <div *ngIf="availableStandardFields.length > 0 && filteredStandardFields.length === 0" class="text-muted small mb-2">
              {{_(KEYS.MASTER_DATA.NO_SEARCH_RESULTS)}}
            </div>
          </div>
        </div>

        <!-- Custom fields section -->
        <div class="fields-section">
          <div class="fields-section-header">{{_(KEYS.MASTER_DATA.CUSTOM_FIELDS)}}</div>
          <div class="available-fields-list" [dragula]="'master-data-fields'">
            <div
              *ngFor="let def of filteredCustomFields"
              class="available-field drag-handle field-type-custom"
              [attr.data-field-key]="def.key"
              [attr.data-field-type]="'custom'"
            >
              <i class="fa fa-arrows mr-2"></i>
              {{def.label}}
            </div>
            <div *ngIf="customDefinitions.length === 0" class="text-muted small mb-2">
              {{_(KEYS.MASTER_DATA.NO_CUSTOM_FIELDS)}}
            </div>
            <div *ngIf="customDefinitions.length > 0 && availableCustomFields.length === 0" class="text-muted small mb-2">
              {{_(KEYS.MASTER_DATA.ALL_CUSTOM_PLACED)}}
            </div>
            <div *ngIf="availableCustomFields.length > 0 && filteredCustomFields.length === 0" class="text-muted small mb-2">
              {{_(KEYS.MASTER_DATA.NO_SEARCH_RESULTS)}}
            </div>
          </div>
        </div>

        <!-- HR divider (can be placed multiple times) -->
        <div class="fields-section" *ngIf="showHrDivider">
          <div class="fields-section-header">{{_(KEYS.MASTER_DATA.ELEMENTS)}}</div>
          <div class="available-fields-list" [dragula]="'master-data-fields'">
            <div
              class="available-field drag-handle field-type-hr"
              data-field-key="hr"
              data-field-type="hr"
            >
              <i class="fa fa-arrows mr-2"></i>
              {{_(KEYS.MASTER_DATA.HR_DIVIDER)}}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Grid layout area -->
    <div class="grid-layout-area">
      <h6>{{_(KEYS.MASTER_DATA.FORM_LAYOUT)}}</h6>
      <div class="grid-layout-area-container">
        <div
          class="grid-container"
          [style.grid-template-columns]="'repeat(' + gridSize.cols + ', 60px)'"
          [style.grid-template-rows]="'repeat(' + gridSize.rows + ', 60px)'"
        >
        <ng-container *ngFor="let row of range(gridSize.rows)">
          <ng-container *ngFor="let col of range(gridSize.cols)">
            <!-- Empty cell (drop target) -->
            <div
              *ngIf="!getFieldAt(col, row)"
              class="grid-cell empty"
              [attr.data-col]="col"
              [attr.data-row]="row"
              [dragula]="'master-data-fields'"
            >
            </div>

            <!-- Placed field (only render at start position) -->
            <div
              *ngIf="isFieldStart(col, row)"
              class="grid-cell occupied field-cell"
              [ngClass]="getFieldTypeClass(getFieldAt(col, row))"
              [style.grid-column]="(col + 1) + ' / span ' + getFieldAt(col, row)?.colSpan"
              [style.grid-row]="(row + 1) + ' / span ' + getFieldAt(col, row)?.rowSpan"
            >
              <div class="field-content">
                <span class="field-label">{{getFieldLabel(getFieldAt(col, row))}}</span>
                <div class="field-actions">
                  <button
                    class="btn btn-sm btn-danger"
                    (click)="onRemoveField(getFieldAt(col, row))"
                    title="{{_(KEYS.MASTER_DATA.REMOVE)}}"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <div
                  class="resize-handle"
                  (mousedown)="onResizeStart($event, getFieldAt(col, row))"
                ></div>
              </div>
            </div>
          </ng-container>
        </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Fixed save footer -->
<div class="save-footer">
  <button class="btn btn-primary" (click)="onSave()" [disabled]="!hasUnsavedChanges || isSaving">
    <i class="fa fa-save"></i> {{_(KEYS.MASTER_DATA.SAVE)}}
    <i class="fa fa-spinner fa-spin ml-1" *ngIf="isSaving"></i>
  </button>

  <div class="vl"></div>

  <button class="btn btn-success" (click)="onLoadDefaultLayout()">
    <i class="fa fa-magic"></i> {{_(KEYS.MASTER_DATA.LOAD_DEFAULT)}}
  </button>

  <button class="btn btn-warning" (click)="onReset()" [disabled]="positions.length === 0">
    <i class="fa fa-refresh"></i> {{_(KEYS.MASTER_DATA.RESET)}}
  </button>
</div>
